export default "__VITE_ASSET__c34657f9__"